export default "__VITE_ASSET__CZoiWQXJ__"